import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from "../pages/login";
import { AuthWrapper } from "@/components/layout/auth-wrapper";
import { PageWrapper } from "@/components/layout/page-wrapper";
import ErrorBoundary from "@/components/Common/error-boundary";
import { SafeWrapper } from "@/components/Common/safe-wrapper";
import { Sidebar } from "@/components/layout/sidebar";
import { useAuthContext } from "@/auth";
import { OverviewPage } from "@/pages/overview";
import { AHUPage } from "@/pages/ahu";
import { AutopilotPage } from "@/pages/autopilot";
import { CreateAutomation } from "@/pages/autopilot/create";
import { AutomationDetail } from "@/pages/autopilot/automation-detail";
import { SettingsPage } from "@/pages/settings";
import { CopilotPage } from "@/pages/copilot";
import { AlarmsPage } from "@/pages/alarms";
import { SavingsPage } from "@/pages/savings";
import MapPage from "@/pages/map";
import AnalyticsPage from "@/pages/analytics";

export function AppRoutes() {
  const { isLoggedIn } = useAuthContext();
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={
          <AuthWrapper
            isAuthenticated={isLoggedIn}
          />
        }>
          <Route
            element={
              <PageWrapper
                sidebar={<Sidebar />}
              />
            }
          >
            {/* <Route path="/" element={<Navigate to={import.meta.env.VITE_APP_MODE === 'multi' ? '/map' : '/overview'} replace />} /> */}
            <Route path="/" element={<Navigate to={'/map'} replace />} />
            <Route path="/overview" element={<SafeWrapper fallbackMessage="Error loading Overview page"><OverviewPage /></SafeWrapper>} />
            <Route path="/ahu" element={<SafeWrapper fallbackMessage="Error loading AHU page"><AHUPage /></SafeWrapper>} />

            {/* Keep only the overview page in autopilot section */}
            <Route path="/autopilot" element={<SafeWrapper fallbackMessage="Error loading Autopilot page. There was an error with the data.">
              <AutopilotPage />
            </SafeWrapper>} />

            {/* Copilot route */}
            <Route path="/copilot" element={<CopilotPage />} />

            {/* Savings route */}
            <Route path="/savings" element={<SafeWrapper fallbackMessage="Error loading Savings page"><SavingsPage /></SafeWrapper>} />

            {/* Map route */}
            <Route path="/map" element={<SafeWrapper fallbackMessage="Error loading Map page"><MapPage /></SafeWrapper>} />

            {/* Move automation creation and detail to settings/automations path */}
            <Route path="/settings/automations/create" element={<CreateAutomation />} />
            <Route path="/settings/automations/edit/:id" element={<AutomationDetail isEditMode={true} />} />
            <Route path="/settings/automations/:id" element={<AutomationDetail isEditMode={false} />} />

            {/* Settings routes */}
            <Route path="/settings/*" element={<SettingsPage />} />
            <Route path="/analytics" element={<SafeWrapper fallbackMessage="Error loading Analytics page"><AnalyticsPage /></SafeWrapper>} />
            <Route path="/alarms" element={<SafeWrapper fallbackMessage="Error loading Alarms page"><AlarmsPage /></SafeWrapper>} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}
